import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ConfirmationRequestPageBase } from '@bo-client/shared/base-components/confirmation-request-page.base';
import { GridRegistrationModel } from '@bo-client/activation-management/grid-registration/model/grid-registration.model';
import { RequestFormBase } from '@bo-client/shared/base-components/request-form.base';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpHapService } from '@bo-client/core/http/http-hap.service';
import { ToastrService } from 'ngx-toastr';
import { RequestApprovalDto } from '@bo-client/activation-management/grid-registration/model/RequestApprovalDto';
import { GridRegistrationRequestService } from '@bo-client/activation-management/grid-registration/grid-registration-request.service';
import { uri } from '@bo-client/shared/constants/uri';
import { Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { getComponentForGridRegistrationExternalType } from '@bo-client/activation-management/grid-registration/grid-registration.utils';
import { GridRegistrationFormDirective } from '@bo-client/activation-management/grid-registration/grid-registration-form.directive';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { AnswerWithMoreInfoModel } from '@bo-client/activation-management/shared/models/AnswerWithMoreInfoModel';
import { path } from '@bo-client/shared/constants/path';
import { ShowErrorModel } from '@bo-client/shared/form-errors/errors-form-model';

@Component({
  selector: 'app-grid-registration-external-feedback',
  templateUrl: './grid-registration-external-feedback.component.html',
  styleUrls: ['./grid-registration-external-feedback.component.scss']
})
export class GridRegistrationExternalFeedbackComponent
  extends ConfirmationRequestPageBase<GridRegistrationModel>
  implements OnInit, OnDestroy
{
  @ViewChild(GridRegistrationFormDirective, { static: true })
  gridRegistrationFormHost!: GridRegistrationFormDirective;

  public form: RequestFormBase<GridRegistrationModel>;
  public uriGetData = uri.cmGridRegistrationRequestExternal;
  public requestApprovalDto: RequestApprovalDto;
  public gridRegistration: GridRegistrationModel = null;

  public compUnsubs$ = new Subject<void>();

  get latestComment() {
    return this.gridRegistration?.activities
      ?.filter((x) => (x.javaclass = 'de.tsg.vs.platform.features.activities.AuditActivity'))
      .map((x) => x.information)
      .join('\n');
  }

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected httpService: HttpHapService,
    protected toastService: ToastrService,
    protected matDialog: MatDialog,
    private dataShareService: DataShareService,
    protected gridRegistrationRequestService: GridRegistrationRequestService
  ) {
    super(route, router, httpService, toastService, matDialog);
    this.title = 'Rückfrage an Kunde';
  }

  ngOnInit(): void {
    super.init();
  }

  hookDataLoaded() {
    this.gridRegistration = this.model;
    this.insertMainForm();

    // entry Point after standard loading data
  }

  insertMainForm() {
    this.dataShareService.tenantConfig$
      .pipe(
        takeUntil(this.compUnsubs$),
        filter((x) => !!x && !!x.gridRegistration)
      )
      .subscribe((tenantConfig) => {
        const viewContainerRef = this.gridRegistrationFormHost.viewContainerRef;
        viewContainerRef.clear();
        console.log('got tenantCOnfig', tenantConfig);
        const componentRef = viewContainerRef.createComponent(
          getComponentForGridRegistrationExternalType(
            this.model.gridRegistrationType,
            this.model.formVersion || tenantConfig.gridRegistration.gridRegistrationFormVersionEnum
          )
        );
        this.form = componentRef.instance;
        componentRef.instance.onErrorsChanged.subscribe((x) => this.onFormErrorsChanged(x));

        this.form.loadFormWithModel(this.model);
        this.form.selectedCompanyLocation = this.model.companyLocation;
      });
    // put the form in :)
  }

  hookGetDataFromForm() {
    // entry Point to modify additionalData to save
    // in base Component additionaldata is loaded with the form structure
  }

  ngOnDestroy() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }

  submit() {
    // Validate the form
    if (!this.form.isValid()) {
      console.log('form is not valid - ', this.form.getAllValidationErrors(), this.form);
      this.toastService.error(
        'Bitte überprüfen Sie Ihre Eingaben' +
          this.form
            .getAllValidationErrors()
            .map((errorModel) => ShowErrorModel.toReadableString(errorModel))
            .join('<br/>'),
        'Bitte überprüfen Sie Ihre Eingaben für folgende Felder:'
      );
      // log all the validation errors for all nested fields
      return;
    }

    this.model = this.form.getModelFromForm();

    this.httpService
      .putOrPost<AnswerWithMoreInfoModel<GridRegistrationModel>>(
        { additionalData: this.model, id: this.model.id, token: this.token },
        uri.cmGridRegistrationRequestExternal
      )
      .pipe(
        takeUntil(this.compUnsubs$),
        tap((answer) => {
          this.router.navigate([path.external + '/' + answer.navigateTo + '/' + answer.message], {
            replaceUrl: true
          });
        })
      )
      .subscribe({
        error: (error) => {
          this.displayErrorMessage(error, 'Beim  Verschicken ist ein Fehler aufgetreten.');
        }
      });
  }
}
